import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../encoding/AbstractEncoder.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NoOpEncoderClass;
function NoOpEncoder() {
  if (NoOpEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static l1z() {
        NoOpEncoder_instance = null;
        var $this = this.r1r();
        NoOpEncoder_instance = $this;
        $this.k1z_1 = EmptySerializersModule();
        return $this;
      }
      n1r() {
        return this.k1z_1;
      }
      t1r(value) {
        return Unit_instance;
      }
      u1r() {
        return Unit_instance;
      }
      v1r(value) {
        return Unit_instance;
      }
      w1r(value) {
        return Unit_instance;
      }
      x1r(value) {
        return Unit_instance;
      }
      y1r(value) {
        return Unit_instance;
      }
      z1r(value) {
        return Unit_instance;
      }
      a1s(value) {
        return Unit_instance;
      }
      b1s(value) {
        return Unit_instance;
      }
      c1s(value) {
        return Unit_instance;
      }
      d1s(value) {
        return Unit_instance;
      }
      e1s(enumDescriptor, index) {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'NoOpEncoder');
    NoOpEncoderClass = $;
  }
  return NoOpEncoderClass;
}
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance === VOID)
    NoOpEncoder().l1z();
  return NoOpEncoder_instance;
}
//region block: exports
export {
  NoOpEncoder_getInstance as NoOpEncoder_getInstance2wgh00a9s97su,
};
//endregion

//# sourceMappingURL=NoOpEncoder.mjs.map
